import forumNav from '@/forumcomponents/forumNav'
import miniNav from '@/forumViews/project/miniNav/miniNav'
export const project = [
	{
		path: '/forum/project',
		name: '_forumProject',
		component: forumNav,
		children: [
			{
				path: '/forum/project',
				redirect: '/forum/project/list',
				component: miniNav,
				children: [
					{
						path: '/forum/project/list',  //未来科学大奖科学峰会
						name: 'forumProjectList',
						component: () => import('@/forumViews/project/list'),
                    }
				],
            },
            {
                path: '/forum/project/detail',
                name: 'forumProjectDetail',
                component: () => import('@/forumViews/project/detail')
            },
            {
                path: '/forum/project/citySummit',
                component: () => import('@/forumViews/project/citySummit/citySummit'),
                meta:{
                    // 页面标题title
                    title: '城市峰会',
                }
            },
            {
                path: '/forum/project/citySummit/selList',
                component: () => import('@/forumViews/project/citySummit/selList')
            },
			{
                path: '/forum/project/citySummit/selDedail',
                component: () => import('@/forumViews/project/citySummit/selDedail')
            },
		],
	},
]
